var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TareaModal',{attrs:{"isPossibleAdditional":_vm.isPossibleAdditional}})
}
var staticRenderFns = []

export { render, staticRenderFns }